import Vue from 'vue';
import Router from 'vue-router';
import Admin from './views/Admin.vue';
import Index from './views/Index.vue';
import Content from './views/Content.vue';
import Embed from './views/Embed.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/campaigns/:id',
      name: 'campaign',
      component: Index,
    },
    {
      path: '/jobs/:areas',
      name: 'filter',
      component: Index,
    },
    {
      path: '/jobs/:areas/:keyword',
      name: 'filter2',
      component: Index,
    },
    {
      path: '/first-login',
      name: 'first-login',
      component: Admin,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: Admin,
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
    },
    {
      path: '/admin/campaigns',
      name: 'campaigns-admin',
      component: Admin,
    },
    {
      path: '/admin/policies',
      name: 'policy-admin',
      component: Admin,
    },
    {
      path: '/admin/users',
      name: 'users-admin',
      component: Admin,
    },
    {
      path: '/admin/content',
      name: 'content-admin',
      component: Admin,
    },
    {
      path: '/admin/info',
      name: 'info-admin',
      component: Admin,
    },
    {
      path: '/embed',
      name: 'embed',
      component: Embed,
    },
    {
      // will match everything
      path: '/:id',
      name: 'content',
      component: Content,
    },
  ],
});
